import httpClient from '../httpClient';

function dataRoomExtend(dataRoomId: string) {
  return httpClient.post<{ token: string }>(
    `data-rooms/${dataRoomId}/auth/extend-token`,
  );
}

export default {
  dataRoomExtend,
};
